<template>
      <div class="swiper">
        <swiper :options="swiperOption" ref="mySwiper">
            <!-- slides -->
            <slot>  
            </slot>
            <div class="swiper-pagination"  slot="pagination"></div>
        </swiper>
      </div>
</template>
<script>
export default {
    name: 'carrousel',
    data() {
      return {
        swiperOption: {
            pagination: {
                el: '.swiper-pagination',
            },
            loop: false,
            // notNextTick: true,
            autoplay: {
                disableOnInteraction: false,
                delay:3000
            },
            autoHeight: true, 
            centeredSlides: true,  
            paginationClickable: true,
        }
      }
    },
    computed: {
      swiper() {
        return this.$refs.mySwiper.swiper
      }
    },
    mounted() {
      // current swiper instance
      // 然后你就可以使用当前上下文内的swiper对象去做你想做的事了
    //   console.log('this is current swiper instance object', this.swiper)
    //   this.swiper.slideTo(1, 1000, false)
    }
  }
</script>
<style lang="scss" scoped>
    
</style>



// WEBPACK FOOTER //
// src/basecomponents/swiper.vue